/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { FullScreen } from 'react-full-screen';
import { ClassNames } from '@emotion/core';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import AriaModal from 'react-aria-modal';
import * as styles from './modal.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Modal = _ref => {
  var children = _ref.children,
    onClose = _ref.onClose,
    onClick = _ref.onClick,
    navItems = _ref.navItems,
    fullscreenHandle = _ref.fullscreenHandle,
    photoCount = _ref.photoCount;
  var FullScreenComponent = fullscreenHandle ? FullScreen : React.Fragment;
  return ___EmotionJSX(ClassNames, null, _ref2 => {
    var css = _ref2.css;
    return ___EmotionJSX(AriaModal, {
      titleText: "Photo Gallery",
      includeDefaultStyles: false,
      underlayClass: css(styles.underlay),
      dialogClass: css(styles.dialog)
    }, ___EmotionJSX(FullScreenComponent, {
      handle: fullscreenHandle
    }, ___EmotionJSX("div", {
      css: styles.contents,
      onClick: onClick
    }, children, ___EmotionJSX("div", {
      css: styles.buttonBar
    }, ___EmotionJSX("div", null, ___EmotionJSX(Button, {
      appearance: "ghost",
      css: styles.closeButton,
      icon: ___EmotionJSX(CloseIcon, null),
      title: "Close",
      onClick: onClose
    })), ___EmotionJSX("div", {
      css: styles.photoCount
    }, photoCount), navItems.length > 0 && ___EmotionJSX("div", null, navItems.map(item => ___EmotionJSX(Button, {
      key: item.title,
      css: styles.navButton,
      appearance: "ghost",
      onClick: item.onClick,
      icon: item.icon,
      title: item.title
    })))))));
  });
};
Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  navItems: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func
  })),
  photoCount: PropTypes.string,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  fullscreenHandle: PropTypes.shape()
};
Modal.defaultProps = {
  navItems: [],
  photoCount: '',
  onClose: () => {},
  onClick: () => {},
  fullscreenHandle: undefined
};
export default Modal;